import { Flex, Text } from '@mantine/core';
import { AlertTitle, Alert } from '@dealstack/frontend/shared/components/Alert/Alert.tsx';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

export const HelpTooltipContent = () => {
	const tMipCreate = useTranslationMipCreate();

	return (
		<Flex direction="column" gap="1rem">
			<Text variant="p-md">{tMipCreate('investors.help.description')}</Text>
			<Alert state="infoV3" size="s">
				<Flex direction="column" gap="1rem">
					<AlertTitle>{tMipCreate('investors.expandable.body.title')}</AlertTitle>

					<div>
						<Text variant="p-md">{tMipCreate('investors.expandable.body.step1')}</Text>
						<Text variant="p-md">{tMipCreate('investors.expandable.body.step2')}</Text>
						<div style={{ marginLeft: '0.75em' }}>
							<Text variant="p-md">
								{tMipCreate('investors.expandable.body.step2a')}
							</Text>
							<Text variant="p-md">
								{tMipCreate('investors.expandable.body.step2b')}
							</Text>
						</div>
						<Text variant="p-md">{tMipCreate('investors.expandable.body.step3')}</Text>
						<Text variant="p-md">{tMipCreate('investors.expandable.body.step4')}</Text>
					</div>

					<Text variant="p-md">{tMipCreate('investors.expandable.body.warning')}</Text>
				</Flex>
			</Alert>
		</Flex>
	);
};
